import React, { useState } from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { Eye, EyeOff } from "lucide-react"; // or any icon library you use

interface PasswordInputProps {
  label?: string;
  placeholder: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  defaultValue?: string | number;
}

const PasswordInput: React.FC<PasswordInputProps> = ({ label, placeholder, register, error, defaultValue }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="mb-4 relative">
      {label && (
        <label className="block text-sm font-semibold text-Black mb-2 capitalize">
          {label}
        </label>
      )}
      <input
        autoComplete="off"
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        defaultValue={defaultValue}
        {...register}
        className={`w-full p-3 pr-10 rounded-[8px] border ${
          error ? "border-danger" : "border-LightGrey3"
        } focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-sm`}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-3 top-[50%] transform  text-DarkGrey3"
      >
        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
      {error && <span className="text-danger text-sm mt-1 block">{error.message}</span>}
    </div>
  );
};

export default PasswordInput;
